module.exports = __webpack_public_path__ + "img/cj_code.f0969cb0.png";